// extracted by mini-css-extract-plugin
export default {"demoNavigation":"DemoNavigation_demoNavigation__tjVJs","buttonGroup":"DemoNavigation_buttonGroup__I+2ol"};